'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AbstractReactComponent = require('./../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _ApiObjectSuggestField = require('./../field/ApiObjectSuggestField');

var _ApiObjectSuggestField2 = _interopRequireDefault(_ApiObjectSuggestField);

var _EsbApi = require('./../api/EsbApi');

var _EsbApi2 = _interopRequireDefault(_EsbApi);

var _Utils = require('./../Utils2');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Subjekt field
 *
 * Suggest
 */
var SubjektField = function (_AbstractReactCompone) {
    (0, _inherits3.default)(SubjektField, _AbstractReactCompone);

    function SubjektField() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, SubjektField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SubjektField.__proto__ || (0, _getPrototypeOf2.default)(SubjektField)).call.apply(_ref, [this].concat(args))), _this), _this.handleFilterSuggestions = function (value) {
            var _this$props = _this.props,
                kodOrganizace = _this$props.kodOrganizace,
                kodRole = _this$props.kodRole;

            return _EsbApi2.default.getSubjekty(value, kodOrganizace, kodRole, 20);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(SubjektField, [{
        key: 'render',
        value: function render() {
            var other = (0, _objectWithoutProperties3.default)(this.props, []);


            return _react2.default.createElement(_ApiObjectSuggestField2.default, (0, _extends3.default)({
                filterSuggestions: this.handleFilterSuggestions,
                getItemValue: function getItemValue(item) {
                    return item ? item.nazev : "";
                },
                renderSuggestion: function renderSuggestion(i, active, getItemValue) {
                    return _react2.default.createElement(
                        'div',
                        { className: active ? "active" : "" },
                        i.nazev
                    );
                }
            }, other));
        }
    }]);
    return SubjektField;
}(_AbstractReactComponent2.default);

SubjektField.PropTypes = {
    kodOrganizace: _react2.default.PropTypes.string.isRequired,
    kodRole: _react2.default.PropTypes.string.isRequired,
    addonsBefore: _Utils.COMPONENT_CHILDREN,
    addonsAfter: _Utils.COMPONENT_CHILDREN
};
SubjektField.defaultProps = {
    apiRequestDelay: 250
};
exports.default = SubjektField;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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